// extracted by mini-css-extract-plugin
export default {"largeScreenWidth":"70","mediumScreenWidth":"38","projectDetailsWidth":"46","projects":"ProjectList_projects__UQ86R","loadingSpinner":"ProjectList_loadingSpinner__vYuyh"};